import React, { useState, useEffect } from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/weatherAlert.scss";

// Bootstrap Components
import Container from "react-bootstrap/Container";

// debug json
import data_debug from "../../../../resources/swt.json";
// END

import { getWeatherAlert } from "../../../service/apiHKOWeatherInfoService";

// Type of information
type alertObject = {
  id: number;
  info: string;
  time: string;
};
// END

function KeyFatch(keyFatchSource: Object): Array<alertObject> {
  let alertInformationArray: Array<alertObject> = new Array<alertObject>();
  let keyIDAlert: number = 0;

  const keys = Object.keys(keyFatchSource) as Array<string>;
  if (keys.length === 0) {
    return alertInformationArray;
  }
  keys.forEach((key) => {
    let keyItem: any = keyFatchSource[key as keyof typeof keyFatchSource];
    let KeyItemTime: string =
      "(" +
      keyItem.updateTime.substring(0, 4) +
      "/" +
      keyItem.updateTime.substring(5, 7) +
      "/" +
      keyItem.updateTime.substring(8, 10) +
      " " +
      keyItem.updateTime.substring(11, 13) +
      ":" +
      keyItem.updateTime.substring(14, 16) +
      "HKT)";

    let alertInformation: alertObject = {
      id: keyIDAlert,
      info: keyItem.desc,
      time: KeyItemTime,
    };

    alertInformationArray.push(alertInformation);
    keyIDAlert += 1;
  });

  return alertInformationArray;
}

function PrintAlert(sourceItem: alertObject) {
  return (
    <div key={"swt" + sourceItem.id} className="weatherAlertBox_Item">
      <div className="weatherAlertBox_ItemInfo">
        {sourceItem.info} {sourceItem.time}
      </div>
      {/* <div className="weatherAlertBox_ItemTime">{sourceItem.time}</div> */}
    </div>
  );
}

function WeatherAlert() {
  const [alertList, setAlertList] = useState<Array<alertObject>>([]);

  async function getFetchAlertInfomation() {
    await getWeatherAlert()
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        setAlertList(KeyFatch(data.swt));
      })
      .catch((error) => {
        console.log(error);
        setAlertList([]);
      });
  }

  useEffect(() => {
    getFetchAlertInfomation();
  }, []);

  if (alertList?.length !== 0 && alertList !== null) {
    return (
      <Container>
        <div id="weatherAlertBox">
          <div id="weatherAlertBox_Title">特別天氣提示(天文台)</div>
          <div>{alertList.map((item) => PrintAlert(item))}</div>
        </div>
      </Container>
    );
  } else {
    return null;
  }
}

export default WeatherAlert;
